import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../models'

import type { Plugin } from './plugin'
import type { State } from './state'

/**
 * Core actions for this {@link Plugin}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig<
  TTypeParams extends ec.models.TypeParams.Constraint,
>(collection: ec.Collection<TTypeParams>) {
  return {
    // TODO: maybe similar idea to have something lik copy, and then have an option "selected: true"
    copySelected: store.actions.standalone({
      data: store.actions.Data.NONE,
    }),
    paste: store.actions.standalone({
      data: store.actions.Data.asIs<{
        readonly dialogConfig: models.DialogConfig
      }>(),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
